import { render, staticRenderFns } from "./ChartOrganizationComponent.vue?vue&type=template&id=308664cb"
import script from "./ChartOrganizationComponent.vue?vue&type=script&lang=js"
export * from "./ChartOrganizationComponent.vue?vue&type=script&lang=js"
import style0 from "./ChartOrganizationComponent.vue?vue&type=style&index=0&id=308664cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports